import styled from "styled-components";
import {JackpotToastTimeAndAmountDefaultBox} from "./jackpot-toast-time-and-amount.default.box";

export const JackpotToastTimeAndAmountCasino777Box = styled(JackpotToastTimeAndAmountDefaultBox)`
    border-radius: 5px;
    background-color: ${props => props.theme.colors.backgroundMiddleDark};
    box-shadow: inset 0 0 6px 0px ${props => props.theme.colors.brandSecondaryDark}, 0 0 7px 0px ${props => props.theme.colors.brandSecondaryDark};
    border: 2px solid ${props => props.theme.colors.brandSecondaryDark};

    @media ${props => props.theme.mediaQuery.mAndBelow} {
    }
`;